import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { ClienteLogin } from '../../../views/login/cliente_login';
import { ListaDiccionaryEntity } from "../../../components/common/utils/entities/lista_dictionary_entity";
import { CancelacionService } from './cancelacion.service';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { ConsultarUsuarioMasivos } from "../../../components/common/utils/consultarUsuarioMasivos";
import { DatosGeneralesService } from "../datosGenerales/datos-generales.service";
import { ClienteIndividualEntity } from "../datosGenerales/entities/datos_generales_individual_entity";
import { FileUploader } from "ng2-file-upload/ng2-file-upload";
import jQuery from "jquery";
import { ConstantService } from "../../../components/common/utils/constant.service";
import { BienSolicitudEntity } from "../datosGenerales/entities/bien_asegurado_entity";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { JwtHelper } from "angular2-jwt/angular2-jwt";

const swal = require("sweetalert2");
declare var jQuery: any;

@Component({
    selector: 'infoCancelacion',
    providers: [CancelacionService],
    templateUrl: 'cancelacion.template.html'
})

export class CancelacionBien implements OnInit {

    motivos: ListaDiccionaryEntity[];
    idMotivo: number;
    usuario: ClienteLogin;
    clienteMasivosIndividual: ClienteIndividualEntity;
    public uploader: FileUploader;
    private url = "infoClienteIndividual";
    bienEntity: BienSolicitudEntity;
    devolverMensaje: any;
    jwtHelper: JwtHelper = new JwtHelper();

    constructor(
        private cancelacionService: CancelacionService,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        private consultarMasivo: ConsultarUsuarioMasivos,
        private datosGeneralesIndividualSevice: DatosGeneralesService,
        public sesionStorageService: SessionStorageService

    ) {
        this.bienEntity = new BienSolicitudEntity();
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;

        this.uploader = new FileUploader({
            url: this.url + '/cancelarBien',
            allowedMimeType: ['image/jpeg',
                              'image/png',
                              'application/pdf',
                              'application/msword',
                              'application/vnd.ms-excel',
                              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                              'application/x-zip-compressed'
                              ],
            maxFileSize: 5*1024*1024, /*limitado a 5 MB*/
            removeAfterUpload: true
        });

        this.uploader.options.headers = [];

        this.uploader.onAfterAddingFile = (file) => {
            file.withCredentials = false;
        };

        this.uploader.onCompleteItem = (item: any, response: any, status: number, headers: any) => {
            this.devolverMensaje(status);
        }

        this.devolverMensaje = (parametro: number): void => {

            if (parametro == 200) {
                swal({
                    title: 'Solicitud de cancelación de bien asegurado',
                    text: 'Su solicitud ha sido enviada exitosamente. En breve, un ejecutivo se comunicará con ud. para concluir el proceso.',
                    type: 'success',
                    confirmButtonColor: '#A14950',
                    confirmButtonText: 'Aceptar'
                }).then(function () {
                        window.location.reload(true);
                    });
            }
            else {
                swal({
                    title: 'Error en solicitud de cancelación',
                    text: 'No se pudo realizar el envío de la solicitud de cancelación, por favor vuelva a intentar. En caso de volver a presentarse el mismo mensaje repórtelo al su ejecutivo de cuenta.',
                    type: 'error',
                    confirmButtonColor: '#A14950',
                    confirmButtonText: 'Aceptar'
                })
            }

        }        

    }

    uploadFilesInQueue(): void {

        if (this.uploader.getNotUploadedItems().length == 1) {

            this.uploader.options.headers.push(
                { name: 'Authorization', value: 'Token ' + this.sesionStorageService.retrieve("Token") },
                //{ name: 'Authorization', value: 'Token ' + sessionStorage.getItem("Token") },
                { name: 'CodigoUsuario', value: this.usuario.CodigoUsuario + "" },
                { name: 'CodigoCiudadTecni', value: this.bienEntity.CodigoCiudadTecni + "" },
                { name: 'CodigoProducto', value: this.bienEntity.CodigoProducto + "" },
                { name: 'CodigoBienAsegurado', value: this.bienEntity.CodigoBienAsegurado + "" },
                { name: 'TipoSolicitud', value: this.bienEntity.TipoSolicitud + "" },
                { name: 'CodigoMotivoCancelacion', value: this.idMotivo + "" },
                { name: 'CodigoCliente', value: this.bienEntity.CodigoCliente + "" },
                { name: 'TipoCobertura', value: this.bienEntity.TipoCobertura + "" },
                { name: 'Observaciones', value: this.bienEntity.Observaciones + "" }
            );

            this.uploader.uploadItem(this.uploader.getNotUploadedItems()[0]);
        } else if (this.uploader.queue.length > 1) {
            this.uploadAllFiles();
            this.uploader.clearQueue();
        }
    }

    uploadAllFiles(): void {
        const xhr = new XMLHttpRequest();
        const form = new FormData();

        for (const fileItem of this.uploader.getNotUploadedItems()) {
            form.append(fileItem.file.name, fileItem._file, fileItem.file.name);
        }

        xhr.onreadystatechange = (function () {
            if (xhr.readyState === 4) {
                this.devolverMensaje(xhr.status);
            }
        }).bind(this);
        xhr.open("post", this.url + '/cancelarBien', true);
        xhr.setRequestHeader("enctype", "multipart/form-data");
        // IE workaround for Cache issues
        xhr.setRequestHeader("Cache-Control", "no-cache");
        xhr.setRequestHeader("Cache-Control", "no-store");
        xhr.setRequestHeader("Pragma", "no-cache");
        //xhr.setRequestHeader("Authorization", "Token " + sessionStorage.getItem("Token"));
        xhr.setRequestHeader("Authorization", "Token " + this.sesionStorageService.retrieve("Token"));
        xhr.setRequestHeader("CodigoUsuario", this.usuario.CodigoUsuario + "");
        xhr.setRequestHeader("CodigoCiudadTecni", this.bienEntity.CodigoCiudadTecni + "");
        xhr.setRequestHeader("CodigoProducto", this.bienEntity.CodigoProducto + "");
        xhr.setRequestHeader("CodigoBienAsegurado", this.bienEntity.CodigoBienAsegurado + "");
        xhr.setRequestHeader("TipoSolicitud", this.bienEntity.TipoSolicitud + "");
        xhr.setRequestHeader("CodigoMotivoCancelacion", this.idMotivo + "");
        xhr.setRequestHeader("CodigoCliente", this.bienEntity.CodigoCliente + "");
        xhr.setRequestHeader("TipoCobertura", this.bienEntity.TipoCobertura + "");
        xhr.setRequestHeader("Observaciones", this.bienEntity.Observaciones + "");
        xhr.send(form);
    };

    GenerarCartaCancelacion(e) {
        e.preventDefault();
        this.bienEntity.CodigoMotivoCancelacion = this.idMotivo;
        this.cancelacionService.generarCartaCancelacion(this.bienEntity).subscribe(result => {
            let fileBlob = result.blob();
            let blob = new Blob([fileBlob], {
                type: 'application/pdf' /* must match the Accept type*/
            });

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob);
            }
            else {
                var fileURL = URL.createObjectURL(blob);
                window.open(fileURL);
            }
        }, error => { this.handleError.redirectUrl(error); });
    }

    estaSeleccionado(): boolean {
        if (this.idMotivo == 0 || this.idMotivo == null)
        { return false; }
        else
        { return true; }
    };

    esVivienda(): boolean {
        if (this.bienEntity.TipoCobertura == 0 || this.bienEntity.TipoCobertura == null)
        { return false; }
        else
        { return true; }
    };

    ngOnInit(): void {
        this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        } else {

            let bandera = this.sessionTokenService.useJwtHelper();
            if (!bandera) {
                this.bienEntity = new BienSolicitudEntity();
                this.bienEntity = jQuery.parseJSON(this.sesionStorageService.retrieve("BienSeleccionado"));
                this.bienEntity.CodigoUsuario = this.usuario.CodigoUsuario;
                this.sesionStorageService.observe("BienSeleccionado").subscribe(v => {
                    this.bienEntity = jQuery.parseJSON(v);
                });
                this.consultarMasivo.iniciarUsuarioMasivo();
                this.datosGeneralesIndividualSevice.datosClienteIndividual().subscribe(
                    datosClienteIndividual => {
                        this.clienteMasivosIndividual = datosClienteIndividual;
                        this.sesionStorageService.store("NombreUser", JSON.stringify(this.clienteMasivosIndividual.Nombres + " " + this.clienteMasivosIndividual.ApellidoPaterno + " " + this.clienteMasivosIndividual.ApellidoMaterno));
                        sessionStorage.setItem("NombreUser", this.clienteMasivosIndividual.Nombres + " " + this.clienteMasivosIndividual.ApellidoPaterno + " " + this.clienteMasivosIndividual.ApellidoMaterno);
                    },
                    error => { this.handleError.redirectUrl(error); });
                this.cancelacionService.consultaMotivos().subscribe(motivos => this.motivos = motivos, error => this.handleError.redirectUrl(error))

            }
        }
    }
}







// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/cancelaciones/cancelacion.component.ts